export default __webpack_public_path__ + "static/media/chippers.d5362372.mp4";